import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
const spaces = {
    normal: 'gap-8',
    wide: 'gap-16',
};
/**
 * ラジオ/チェック ボタン+ラベル のグループ化（wrap）コンポーネント
 * NOTE: デザインシステムのルールに基づいて値を設定をしています
 * WARNING: 設定値の変更, 追加をする場合は、デザインデータの更新必須（none 等は例外）
 * @param props
 * @returns
 */
export const FormGroup = (props) => {
    const { children, className = '', row = false, space = 'normal' } = props;
    return (_jsx("div", Object.assign({ className: clsx('flex', spaces[space], row ? 'flex-row flex-wrap' : 'flex-col flex-nowrap', className) }, { children: children })));
};
